const products = [
    { seq: 1, name: 'Trial Product' },
    { seq: 2, name: 'Commercial Product' }
];
export { products };
